import { STATI } from "@/lib/api";

export const StatoBadge = ({ stato }) => {
  const s = STATI[stato] || STATI.ricevuto;
  return (
    <span className={`inline-block rounded-full px-2.5 py-0.5 text-xs font-semibold ${s.color}`}>
      {s.label}
    </span>
  );
};

export const ScadenzaBadge = ({ giorni }) => {
  if (giorni === null || giorni === undefined) {
    return <span className="rounded-full px-2.5 py-0.5 text-xs font-semibold bg-[#E5E2DC] text-[#5C5F58]">Senza data</span>;
  }
  let cls = "bg-[#E8F0E9] text-[#2F5235]";
  let label = `Tra ${giorni}g`;
  if (giorni < 0) {
    cls = "bg-[#FBE3DA] text-[#B84223]";
    label = `Scaduto da ${Math.abs(giorni)}g`;
  } else if (giorni === 0) {
    cls = "bg-[#FBE3DA] text-[#B84223]";
    label = "Scade oggi";
  } else if (giorni <= 7) {
    cls = "bg-[#FBE3DA] text-[#B84223]";
  } else if (giorni <= 15) {
    cls = "bg-[#FBEAD2] text-[#A86616]";
  } else if (giorni <= 30) {
    cls = "bg-[#FBEAD2] text-[#A86616]";
  }
  return <span className={`inline-block rounded-full px-2.5 py-0.5 text-xs font-semibold ${cls}`}>{label}</span>;
};
